import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { GET_TRANSACTION_DETAILS_BY_CLAIM_ID } from '@/modules/transaction/hooks/useGetTransactionDetails.query';

interface Payload {
  claimId: string;
  description: string;
  documentFilePaths?: string[];
}

const useSubmitClaimAppealQuery = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading } = useMutation(
    ({ claimId, description, documentFilePaths }: Payload) =>
      api.post(API_URL.CLAIMS_APPEAL_BY_CLAIM_ID(claimId), {
        description,
        document_file_paths: documentFilePaths,
      }),
    {
      onSuccess: (_, { claimId }) => {
        queryClient.invalidateQueries({
          queryKey: [GET_TRANSACTION_DETAILS_BY_CLAIM_ID, claimId],
        });
      },
    }
  );

  return {
    submitClaimAppeal: mutateAsync,
    isLoading,
  };
};

export default useSubmitClaimAppealQuery;
